import {
  authorize
} from '@/api/net-api'
import {
  getToken,
  clearToken
} from '@/libs/util'

const cookieToken = getToken()
export default {
  state: {
    token: cookieToken
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    clearToken (state) {
      clearToken()
      state.token = null
    }
  },
  actions: {
    // 登录
    handleAuthorize ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        authorize().then(res => {
          const token = res.data.token
          commit('setToken', token)
          resolve()
        }).catch(err => {
          if (err.status === 401) {
            reject('401')
          } else {
            reject(err)
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/token.js